// window.qrTick = function() {
//   canvasElement.height = video.videoHeight;
//   canvasElement.width = video.videoWidth;
//   canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);

//   scanning && requestAnimationFrame(qrTick);
// }

// window.qrScan = function() {
//   try {
//     qrcode.decode();
//   } catch (e) {
//     setTimeout(qrScan, 300);
//   }
// }

window.addEventListener('load', function() {
  // const qrcode = window.qrcode;

  // const video = document.createElement("video");
  // const canvasElement = document.getElementById("qr-canvas");
  // const canvas = canvasElement.getContext("2d");

  // const qrResult = document.getElementById("qr-result");
  // const outputData = document.getElementById("qrOutputData");
  // const btnScanQR = document.getElementById("btn-scan-qr");

  // let scanning = false;

  // qrcode.callback = res => {
  //   if (res) {
  //     outputData.innerText = res;
  //     outputData.dispatchEvent(new Event('change'));
  //     scanning = false;

  //     video.srcObject.getTracks().forEach(track => {
  //       track.stop();
  //     });

  //     qrResult.hidden = false;
  //     canvasElement.hidden = true;
  //     btnScanQR.hidden = false;
  //   }
  // };
})
